import React, { ComponentPropsWithoutRef } from 'react';
import { Accordion } from '@rbx/ui';
import useMarkdownAccordionStyles from './MarkdownAccordion.styles';

type AccordionProps = ComponentPropsWithoutRef<typeof Accordion>;

export default function BaseAccordion({ children }: AccordionProps) {
  const {
    classes: { accordion },
  } = useMarkdownAccordionStyles();

  return (
    <Accordion
      classes={{
        root: accordion,
      }}>
      {children}
    </Accordion>
  );
}
